import { ref } from 'vue';

export function useDebounce() {
    const debounceTimers = ref({});

    const debounce = (key, callback, delay = 500) => {
        return (...args) => {
            if (debounceTimers.value[key]) {
                clearTimeout(debounceTimers.value[key]);
            }
            debounceTimers.value[key] = setTimeout(() => {
                callback(...args);
                delete debounceTimers.value[key];
            }, delay);
        };
    };

    return { debounce };
}